import { Type } from 'main.core';

export class eCommerse {
	constructor(options = { name: 'eCommerse' }) {
		this.name = options.name;
		if (!window.dataLayer) {
			window.dataLayer = [];
		}
	}

	setDataLayer(type) {
		window.dataLayer.push({ ecommerce: this.setObjectByType(type) });
	}

	getCalculateValue(products) {
		const initialValue = 0;
		return (
			products.reduce(
				(accumulator, arProduct) => Math.round(accumulator + (arProduct.price * arProduct.quantity)),
				initialValue
			)
		);
	}

	setImpressionsEvent(products) {
		const productList = this.getProductList(products, true);

		if (productList.length > 0) {
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'view_item_list',
				ecommerce: {
					currency: 'RUB',
					items: productList,
				},
			});
		}
	}

	setClickEvent(products) {
		const productList = this.getProductList(products, true, 1);

		if (productList.length > 0) {
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'select_item',
				ecommerce: {
					currency: 'RUB',
					value: this.getCalculateValue(productList),
					items: productList,
				},
			});
		}
	}

	setAddProductEvent(products, quantity) {
		const productList = this.getProductList(products, null, quantity);

		if (productList.length > 0) {
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'add_to_cart',
				ecommerce: {
					currency: "RUB",
					value: this.getCalculateValue(productList),
					items: productList,
				},
			});
		}
	}

	setRemoveProductEvent(products, quantity) {
		const productList = this.getProductList(products, null, quantity);

		if (productList.length > 0) {
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'remove_from_cart',
				ecommerce: {
					currency: "RUB",
					value: this.getCalculateValue(productList),
					items: productList,
				},
			});
		}
	}

	setAddToWishListProductEvent(products) {
		const productList = this.getProductList(products, null, 1);

		if (productList.length > 0) {
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'add_to_wishlist',
				ecommerce: {
					currency: "RUB",
					value: this.getCalculateValue(productList),
					items: productList,
				},
			});
		}
	}

	setViewProductEvent(products) {
		const productList = this.getProductList(products);

		if (productList.length > 0) {
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'view_item',
				ecommerce: {
					currency: 'RUB',
					items: productList,
				},
			});
		}
	}

	setViewCartEvent(products) {
		const productList = this.getProductList(products, false, false);

		if (productList.length > 0) {
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'view_cart',
				ecommerce: {
					currency: "RUB",
					value: this.getCalculateValue(productList),
					items: productList,
				},
			});
		}
	}

	setBeginCheckoutEvent(products) {
		const productList = this.getProductList(products, false, false);

		if (productList.length > 0) {
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'begin_checkout',
				ecommerce: {
					currency: "RUB",
					value: this.getCalculateValue(productList),
					items: productList,
				},
			});
		}
	}

	setPurchaseEvent(products, order_id, order_price, order_shipping, order_tax, coupon = null) {
		const productList = this.getProductList(products);

		if (productList.length > 0) {
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'purchase',
				ecommerce: {
					currency: "RUB",
					value: order_price,
					transaction_id: order_id,
					tax: order_tax,
					shipping: order_shipping,
					coupon: coupon,
					items: productList,
				},
			});
		}
	}

	setPromoViewEvent(list) {
		const promoList = this.getPromotionList(list);

		const iPromoId = +promoList[0].promotion_id;

		if (window.shownPromo) {
			if (window.shownPromo.includes(iPromoId))
				return;
		} else {
			window.shownPromo = [];
		}

		window.shownPromo.push(iPromoId);

		if (promoList.length > 0) {
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'view_promotion',
				ecommerce: {
					items: promoList
				},
			});
		}
	}

	setPromoClickEvent(id, name, position) {
		if (id) {
			window.dataLayer.push({ ecommerce: null });
			window.dataLayer.push({
				event: 'select_promotion',
				ecommerce: {
					items: [{
						promotion_id: id,
						promotion_name: name,
						index: position,
					}],
				},
			});
		}
	}

	getProductList(products, position = null, quantity = 0) {
		return products.map((item, key) => {
			let price = 0;
			if (typeof MATRIX !== 'undefined') {
				const { PRICE_MATRIX: { MATRIX } } = item;
			}
			if (typeof MATRIX !== 'undefined') {
				const key = Object.keys(MATRIX);
				const INF = MATRIX[key[0]];
				if (INF['ZERO-INF']) {
					const { DISCOUNT_PRICE } = INF['ZERO-INF'];
					price = DISCOUNT_PRICE;
				}
			} else {
				price = item.PRICE;
			}
			const result = {
				item_id: item.ID,
				item_name: item.NAME,
				price,
				item_brand: 'Erborian',
				item_category: (item.GA_SECTION_NAME ?? item.IBLOCK_SECTION_NAME ?? item.SECTION_NAME ?? ''),
				item_variant: (item.GA_VARIANT ? item.GA_VARIANT + ' мл' : ''),
				item_list_name: (item.GA_LIST_NAME ?? ''),
				item_list_id: (item.GA_LIST_ID ?? ''),
			}
			if (position) {
				result['index'] = key + 1;
			}
			if (item.position) {
				result['index'] = item.position;
			}
			if (quantity) {
				result['quantity'] = quantity;
			}
			if (item.QUANTITY && !quantity) {
				result['quantity'] = parseInt(item.QUANTITY, 10);
			}
			return result;
		});
	}

	getPromotionList(list) {
		return list.map((item, key) => {
			return {
				promotion_id: item.ID,
				promotion_name: item.NAME,
				index: item.POSITION,
			};
		});
	}

	findProduct(id, list) {
		return list.find(item => {
			return item.ID === id;
		});
	}

	validateJson(string) {
		try {
			return JSON.parse(string);
		} catch (e) {
			throw new Error(e);
		}
	}

	setName(name) {
		if (Type.isString(name)) {
			this.name = name;
		}
	}

	getName() {
		return this.name;
	}
}
